import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Dropdown from '../../../common/dropdown/Dropdown';
import { useGetStatesMutation } from '../../../features/businessRegistration/businessRegistrationSlice';
import { TStep5Info } from '../../../types';
import { decryptJson } from '../../../utils/decryptJson';
import { encryptData } from '../../../utils/encryptJson';
import { logUserOut } from '../../../utils/logUserOut';

import './businessRegistration.css';

type TProps = {
  info: TStep5Info;
  setInfo: React.Dispatch<React.SetStateAction<TStep5Info[]>>;
  index_: number;
  data: TStep5Info[];
  setStatesApiError: React.Dispatch<React.SetStateAction<boolean>>;
};
const BusinessResidentAddressForm = ({
  info,
  setInfo,
  index_,
  data,
  setStatesApiError,
}: TProps) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [states, setStates] = useState<any[]>([]);

  const [getStates, { isLoading }] = useGetStatesMutation();
  useEffect(() => {
    const handleGetStates = async () => {
      try {
        const body = encryptData({});
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const data = (await getStates(body as any).unwrap()) as any;
        const res = decryptJson(data?.data);
        setStates(res);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (err: any) {
        logUserOut(err?.status);
        setStatesApiError(true);
      }
    };
    handleGetStates();
  }, [getStates]);

  useEffect(() => {
    const handleGetStates = async () => {
      try {
        const body = encryptData({});
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const data = (await getStates(body).unwrap()) as any;
        const res = decryptJson(data?.data);
        setStates(res);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (err: any) {
        setStatesApiError(true);
      }
    };
    handleGetStates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className='formCont stepFive'>
      <h4>Street number and name</h4>
      <div className='mb-[27px] flex gap-3 '>
        <div className='w-[90px]'>
          <div className='mb-[0]'>
            {/* <label className='flex flex-col relative text-[#212121] '>Business name 1</label> */}
            <input
              className='w-full h-[52px] px-4 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '
              value={info?.streetNumber ?? ''}
              placeholder={'#'}
              onChange={(e) => {
                const newState = data.map((obj, index) => {
                  if (index === index_) {
                    return { ...obj, streetNumber: e.target.value };
                  }

                  return obj;
                });

                setInfo(newState);
              }}
            />
          </div>
        </div>
        <div className='w-full'>
          <div className='mb-[0]'>
            {/* <label className='flex flex-col relative text-[#212121] '>Business name 1</label> */}
            <input
              className='w-full h-[52px] px-4 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '
              value={info?.streetName ?? ''}
              placeholder={'Type street name'}
              onChange={(e) => {
                const newState = data.map((obj, index) => {
                  if (index === index_) {
                    return {
                      ...obj,
                      streetName: e.target.value.replace(/[0-9]/g, ''),
                    };
                  }

                  return obj;
                });

                setInfo(newState);
              }}
            />
          </div>
        </div>
      </div>
      <div className='w-full text-xs mb-[27px]'>
        <Dropdown
          className='border rounded-[2px] !h-[52px] '
          label='Located State'
          isLoading={isLoading}
          labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
          options={
            states &&
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            states.map((state: any) => {
              return {
                label: state.name,
                value: state.name,
              };
            })
          }
          placeholder={info?.locatedState}
          setSelectedOption={(e: { label: string; value: string }) => {
            const newState = data.map((obj, index) => {
              if (index === index_) {
                return { ...obj, locatedState: e.value };
              }

              return obj;
            });

            setInfo(newState);
          }}
          width='100%'
        />
      </div>
      <div className='w-full text-xs mb-[27px] '>
        <label className='flex flex-col relative text-[#212121] '>City or Town</label>
        <input
          className='w-full h-[52px] px-4 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '
          value={info?.cityOrTown ?? ''}
          placeholder={'Type name of city or town'}
          min={3}
          onChange={(e) => {
            const newState = data.map((obj, index) => {
              if (index === index_) {
                return {
                  ...obj,
                  cityOrTown: e.target.value.replace(/[0-9]/g, ''),
                };
              }

              return obj;
            });

            setInfo(newState);
          }}
        />
        {/* <Dropdown
          className='border rounded-[2px] !h-[52px] '
          label='City or Town'
          labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
          options={
            states &&
            states
              ?.find((item: any) => item?.name === info?.locatedState)
              ?.lgas?.map((item: any) => {
                return {
                  label: item,
                  value: item,
                };
              })
          }
          isLoading={isLoading}
          placeholder={info?.cityOrTown}
          setSelectedOption={(e: { label: string; value: string }) => {
            const newState = data.map((obj, index) => {
              if (index === index_) {
                return { ...obj, cityOrTown: e.value };
              }

              return obj;
            });

            setInfo(newState);
          }}
          width='100%'
        /> */}
      </div>
      <div className='w-full text-xs  '>
        <Dropdown
          className='border rounded-[2px] !h-[52px] '
          label='Local Government Area'
          labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
          options={
            states &&
            states
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              ?.find((item: any) => item?.name === info?.locatedState)
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              ?.lgas?.map((item: any) => {
                return {
                  label: item,
                  value: item,
                };
              })
          }
          placeholder={info?.lga}
          isLoading={isLoading}
          setSelectedOption={(e: { label: string; value: string }) => {
            const newState = data.map((obj, index) => {
              if (index === index_) {
                return { ...obj, lga: e.value };
              }

              return obj;
            });

            setInfo(newState);
          }}
          width='100%'
        />
      </div>
    </div>
  );
};

export default BusinessResidentAddressForm;
